import { isEmpty } from 'lodash';
import { useMemo } from 'react';

import { GlobalTranslationItemDataFragment } from '../../../data/types/api/graphql';
import { CustomFormattedMessage } from '../../../elements/intl/custom-formatted-message';
import { GlobalTranslationListItem } from './global-translation-list-item';

type GlobalTranslationListProps = {
  loading?: boolean;
  items: GlobalTranslationItemDataFragment[];
  onClick?: (value: GlobalTranslationItemDataFragment) => void;
};

export function GlobalTranslationsList({
  loading = false,
  onClick,
  ...props
}: GlobalTranslationListProps) {
  const items = useMemo(() => props.items, [props.items]);

  if (loading) {
    return (
      <p>
        <CustomFormattedMessage id="common.loading" />
      </p>
    );
  }

  if (isEmpty(items)) {
    return (
      <p>
        <CustomFormattedMessage id="common.no-data" />
      </p>
    );
  }

  return (
    <div className="content-list">
      {items.map(option => (
        <div
          key={`${option.key}-${option.type}`}
          className="content-list__item"
        >
          <GlobalTranslationListItem translation={option} onClick={onClick} />
        </div>
      ))}
    </div>
  );
}
